import { render, staticRenderFns } from "./ApplicationSummary.vue?vue&type=template&id=4d5853b5&scoped=true&"
import script from "./ApplicationSummary.vue?vue&type=script&lang=js&"
export * from "./ApplicationSummary.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationSummary.vue?vue&type=style&index=0&id=4d5853b5&scoped=true&lang=css&"
import style1 from "./ApplicationSummary.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5853b5",
  null
  
)

export default component.exports